import { useEffect, useRef } from 'react';
import type { DividerProps } from './types';
import { bridge } from '../../../../utils';

export const useLogDisplayDivider = (
  entity: DividerProps['entity'],
  isVisible?: boolean,
) => {
  const logged = useRef(false);

  useEffect(() => {
    if (logged.current || !isVisible || !entity) {
      return;
    }

    const hasDisplayEvent = entity.some(
      (divider) => divider.item.display_event_name,
    );
    if (!hasDisplayEvent) {
      return;
    }

    logged.current = true;

    entity.forEach((divider) => {
      if (!divider.item.display_event_name) {
        return;
      }

      bridge.logAnalyticsEvent({
        channel: ['firebase', 'facebook', 'ablylog'],
        name: divider.item.display_event_name,
        analytics: divider.logging.analytics,
        ably_only_log: divider.logging.ably_only_log,
      });
    });
  }, [isVisible, entity]);
};
